export default function isEmptyParent(issue) {
  return (
    issue.issue_type === "EMPTY_PARENT" &&
    issue.subissueData &&
    issue.subissueData.isSubissueParent &&
    issue.subissueData.subissues
  );
}
